const fieldTranslateMap = {
    TECHNICAL_PROBLEM: 'AI_TECHNICAL_PROBLEM',
    PATENT_INNO_SUMMARY: 'AI_TECHNICAL_METHOD',
    EFFICIENCY_SENTENCE: 'AI_TECHNICAL_BENEFIT',
};
export function translateField(fields) {
    const translatedFields = fields.map(field => fieldTranslateMap[field] || field);
    return [...new Set(translatedFields)];
}
